export const TWENTY_TENS = '2010s';
export const TWO_THOUSANDS = '2000s';
export const NINETIES = '90s';
export const EIGHTIES = '80s';
export const SEVENTIES = '70s';
export const SIXTIES = '60s';
export const FIFTIES = '50s';
export const FOURTIES = '40s';
export const THIRTIES = '30s';
export const TWENTIES = '20s';
export const EIGHTEEN_EIGHTIES = '1880s';
export const EIGHTEEN_SEVENTIES = '1870s';
export const EIGHTEEN_FOURTIES = '1840s';

export const DECADES = [
	TWENTY_TENS,
	TWO_THOUSANDS,
	NINETIES,
	EIGHTIES,
	SEVENTIES,
	SIXTIES,
	FIFTIES,
	FOURTIES,
	THIRTIES,
	TWENTIES,
	EIGHTEEN_EIGHTIES,
	EIGHTEEN_SEVENTIES,
	EIGHTEEN_FOURTIES,
];
